export enum TagGroupType {
  Recommendations = "Recommendations",
  AgreementText = "AgreementText",
  ProductFlagging = "ProductFlagging",
  ProductDescription = "ProductDescription",
  ProductName = "ProductName",
  Disclaimer = "Disclaimer",
  Rules = "Rules",
}

export enum TagType {
  Disclamier = "Disclamier",
  AgreementText = "AgreementText",
  ProductNew = "ProductNew",
  Campaign = "Campaign",
  AssembledAndReady = "AssembledAndReady",
  ProductName = "ProductName",
  IsWheel = "IsWheel",
  IsVgsWheel = "IsVgsWheel",
  GDPR = "GDPR",
  LinkEUlabelingTires = "LinkEUlabelingTires",
}
